import type * as PusherPushNotifications from "@pusher/push-notifications-web";

let beamsClient: PusherPushNotifications.Client | null = null;

export async function initBeamsClient(
	instanceId: string,
): Promise<PusherPushNotifications.Client | null> {
	if (beamsClient) return beamsClient;

	try {
		const { Client } = await import("@pusher/push-notifications-web");
		beamsClient = new Client({ instanceId });
		return beamsClient;
	} catch {
		console.warn("Push notifications not supported");
		return null;
	}
}

export async function startBeams(
	instanceId: string,
	userId: string,
	settings: { messages?: boolean; newsletter?: boolean },
): Promise<void> {
	const client = await initBeamsClient(instanceId);
	if (!client) return;

	try {
		const interests: string[] = [];
		if (settings.messages !== false) {
			interests.push(`chat.${userId}`);
		}
		if (settings.newsletter !== false) {
			interests.push("newsletter");
		}

		await client.start();

		// Bestehende Interests abgleichen: nicht mehr gewünschte entfernen, neue hinzufügen
		const currentInterests = await client.getDeviceInterests();
		for (const interest of currentInterests) {
			if (!interests.includes(interest)) {
				await client.removeDeviceInterest(interest);
			}
		}
		for (const interest of interests) {
			await client.addDeviceInterest(interest);
		}
	} catch (err) {
		console.warn("Failed to start push notifications:", err);
	}
}

export async function stopBeams(): Promise<void> {
	if (!beamsClient) return;
	try {
		await beamsClient.stop();
		beamsClient = null;
	} catch {
		// Cleanup-Fehler ignorieren
	}
}

export function getBeamsClient(): PusherPushNotifications.Client | null {
	return beamsClient;
}
